'use client';

import React from 'react';
import { ArrowUp } from 'lucide-react';
import { css } from 'styled-system/css';

import Tooltip from '@shaojiang/components/Tooltip';
import { IconButton } from '@shaojiang/components/ui/icon-button';
import { useDomStore } from '@shaojiang/store/dom';

export default function ShaojiangScrollToTop() {
  const scrollTop = useDomStore((state) => state.scrollTop);
  const setScrollTop = useDomStore((state) => state.setScrollTop);

  if (scrollTop <= 600) {
    return null;
  }

  return (
    <div className={css({ position: 'fixed', right: '8', bottom: '8', zIndex: 'sticky' })}>
      <Tooltip title='Scroll to Top' placement='top'>
        <IconButton
          size='xl'
          borderRadius='full'
          aria-label='Scroll to top'
          onClick={() => setScrollTop(0)}
          animation='fade-in'
        >
          <ArrowUp />
        </IconButton>
      </Tooltip>
    </div>
  );
}
